const NEXUS_API_URLS = {
    refreshAllMaterializedViews: '/evolveRefreshAllMaterializedViews'
}

export default NEXUS_API_URLS
